<template>
    <div class="todayRain">
      <!-- <h3>每日关注</h3> -->
      <el-row style="text-align:center;background-color:#004db1;margin-bottom:10%;">
        <img style="margin:0 auto" src="@/assets/mimg/mlogo.png" alt="">
      </el-row>
      <el-row :gutter="14">
        <el-col :span="12"><div class="color1" @click.prevent="rainBtn"><img src="@/assets/mimg/jyyb.png" alt="">降雨预报</div></el-col>
        <el-col :span="12"><div class="color1" @click.prevent="wxBtn"><img src="@/assets/mimg/wxyt.png" alt="">卫星云图</div></el-col>
        <el-col :span="12"><div class="color2" @click.prevent="ldBtn"><img src="@/assets/mimg/ld.png" alt="">雷达影像</div></el-col>
        <el-col :span="12"><div class="color2" @click.prevent="tfBtn"><img src="@/assets/mimg/tf.png" alt="">台风路径</div></el-col>
        <el-col :span="12"><div class="color3" @click.prevent="rainFbBtn"><img src="@/assets/mimg/jyfb.png" alt="">降雨分布</div></el-col>
        <el-col :span="12"><div class="color3" @click.prevent="rainSkBtn"><img class="sk" src="@/assets/mimg/jysk.png" alt="">降雨实况</div></el-col>
        <el-col :span="12"><div class="color4" @click.prevent="HdBtn"><img src="@/assets/mimg/hd.png" alt="">河道水情</div></el-col>
        <el-col :span="12"><div class="color4" @click.prevent="SkBtn"><img src="@/assets/mimg/sk.png" alt="">水库水情</div></el-col>
      </el-row>
      <div style="margin-top:10%">
        <el-row style="line-height:36px;text-align:center;background-color:#004db1;color:#fff;">
          <p>制作维护：湖南省水文水资源勘测中心</p>
          <p>联系电话：0731-85531964</p>
        </el-row>
      </div>
    </div>
</template>

<script>

export default {
  name: 'MobileIndex',
  data () {
    return {
      rainImg: false
    }
  },
  methods: {
    rainBtn(){
      // this.rainImg=true;
      this.$router.push({path:'jyyb'})
    },
    wxBtn(){
      this.$router.push({path:'wxyt'})
    },
    ldBtn(){
      this.$router.push({path:'leida'})
    },
    tfBtn(){
      this.$router.push({path:'typhoon'})
    },
    rainFbBtn(){
      this.$router.push({path:'rainFb'})
    },
    rainSkBtn(){
      this.$router.push({path:'rainSk'})
    },
    HdBtn(){
      this.$router.push({path:'Hd'})
    },
    SkBtn(){
      this.$router.push({path:'Sk'})
    }
  },

  watch:{
   
  },
  components: {
    // jyyb
  }
}
</script>

<style scoped lang='less'>
.todayRain{
  font-size: 16px;
  h3{
    color: #333;
    line-height: 36px;
    text-align: center
  }
  .color1{
    img{
      padding: 24px;
      width: 80px;
      height: 80px;
    }
    display: flex;
    background-color:#008000;
    color: #fff;
    text-align: center;
    line-height: 80px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .color2{
    img{
      padding: 24px;
      width: 80px;
      height: 80px;
    }
    display: flex;
    background-color:rgba(0,128,128,1);
    color: #fff;
    text-align: center;
    line-height: 80px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .color3{
    img{
      padding: 12px;
      width: 80px;
      height: 80px;
    }
    .sk{
      padding: 4px;
      width: 80px;
      height: 80px;
    }
    display: flex;
    background-color:rgba(128,128,0,1);
    color: #fff;
    text-align: center;
    line-height: 80px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .color4{
    img{
      padding: 24px;
      width: 80px;
      height: 80px;
    }
    display: flex;
    background-color:rgba(0,128,255,1);
    color: #fff;
    text-align: center;
    line-height: 80px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileIndex.vue